
<template>
  <div class="header-wrapper">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="container nav-inner">
        <!-- Logo -->
        <div class="logo-box" @click="$router.push('/')">
          <img v-if="logo" :src="fixUrl(logo)" alt="惠根" class="logo-img">
          <span v-else class="logo-text">惠根</span>
        </div>

        <!-- 导航菜单 -->
        <div class="nav-menu">
          <ul class="nav-list" v-if="navList.length">
            <li class="nav-item">
              <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
                {{ $t('m.home') }}
              </router-link>
            </li>
            <li class="nav-item has-child" v-for="(item, index) in navList" :key="index">
              <router-link
                class="nav-link"
                :class="{ active: isNavActive(item, index) }"
                :to="{
                  path: getNavPath(item),
                  query: { pname: item.name, pid: item.id }
                }"
              >
                {{ item.name }}
                <i class="nav-caret" v-if="item.child && item.child.length"></i>
              </router-link>
              <!-- 二级菜单 -->
              <ul class="sub-menu" v-if="item.child && item.child.length">
                <li v-for="(child, cIndex) in item.child" :key="cIndex" class="sub-menu-item">
                  <router-link
                    class="sub-menu-link"
                    :to="{
                      path: getNavPath(child),
                      query: { pname: child.name, pid: child.id }
                    }"
                  >
                    {{ child.name }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 品牌首屏（仅首页）：纯色深棕底 + 标题 + 行动按钮 + 右侧二维码 -->
    <div class="brand-hero" v-if="isHome">
      <div class="container hero-inner">
        <div class="hero-text">
          <div class="hero-eyebrow">{{ $t('m.heroEyebrow') }}</div>
          <h1 class="hero-title">
            <span class="hero-title-1">{{ heroTitle }}</span>
            <span class="hero-title-2">{{ heroTitle2 }}</span>
          </h1>
          <p class="hero-sub" v-if="heroSubtitle">{{ heroSubtitle }}</p>
          <div class="hero-acts">
            <span class="hero-btn hero-btn-main" @click="goQualification">{{ $t('m.learnBrand') }}</span>
            <span class="hero-btn hero-btn-ghost" @click="goProducts">{{ $t('m.viewProducts') }}</span>
          </div>
        </div>
        <!-- ============ 二维码区（右列） ============
             结构：hero-qrcode（横向容器）> hero-qrcode-col（单码一列，可多个）> box 白底 + img + caption 文字
             数据：来自后台配置 name=qrcodes，支持逗号分隔多图 或 JSON 数组 [{name,img}]
             说明：名字为空时不显示 caption 文字
        -->
        <div class="hero-qrcode" v-if="qrItems.length">
          <div class="hero-qrcode-col" v-for="(q, i) in qrItems" :key="i">
            <div class="hero-qrcode-box">
              <img :src="fixUrl(q.img)" :alt="q.name || $t('m.heroQrcodeAlt')" class="hero-qrcode-img">
            </div>
            <p class="hero-qrcode-caption" v-if="q.name">{{ q.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from "../request/base";
import {
  CONFIG_INDEX,
  getConfigValue as getCfg,
  getConfigByName,
  fixUrl as fixImgUrl,
  translateNavName
} from "../utils/site";

export default {
  name: 'Header',
  props: {
    msg: String
  },
  data() {
    return {
      logo: '',
      navList: [],
      heroTitle: '',
      heroTitle2: '',
      heroSubtitle: '',
      qrItems: [],
      imgurl: url.baseUrlimg
    }
  },
  computed: {
    // 品牌首屏只在首页展示
    isHome() {
      return this.$route.path === '/'
    }
  },
  created() {
    // 整站英文暂下线：固定中文，不读 localStorage.lang
    this.$i18n.locale = 'zh'
    this.getAbout()
    this.getnavList()
  },
  methods: {
    // 安全读取站点配置：后台配置条数变化会导致索引错位，这里统一兜底防白屏
    getConfigValue(config, index, fallback) {
      return getCfg(config, index, fallback)
    },
    // 拼接图片地址：后端若已返回完整 URL 则不再拼前缀，避免破图
    fixUrl(path) {
      return fixImgUrl(this.imgurl, path)
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return ''
      // 如果是10位时间戳，转成13位
      if (String(timestamp).length === 10) {
        timestamp = timestamp * 1000
      }
      const date = new Date(Number(timestamp))
      if (isNaN(date.getTime())) return timestamp
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    // 根据分类项获取跳转路径
    // 说明：后端分类 type 只区分展示形态（list/imglist/page），同一形态的多个顶级分类
    // 共用同一模板路由（如 imglist → /qualification）。但「加入我们」虽是 imglist，
    // 页面形态是「有子分类的文字列表」，需独立路由 /join 承载（去"全部"、无图），
    // 因此按名称特判，避免被通用映射导到资质荣誉(/qualification)的带图模板。
    getNavPath(item) {
      const type = item && item.type
      if (item && typeof item.name === 'string' && item.name.indexOf('加入我们') > -1) {
        return '/join'
      }
      const pathMap = {
        'table': '/latestbroadcast',
        'list': '/salesdepartmentukbranch',
        'page': '/about',
        'imglist': '/qualification',
        'contact': '/contact',
        'join': '/join'
      }
      return pathMap[type] || '/qualification'
    },
    // 判断导航是否激活
    // 修法说明：旧实现用 path.indexOf 太宽松（子串误命中），且公司简介(page)和加入我们(join)
    // 共用 /about 路径，导致两者会被同时激活。改为：
    //   1) 路径严格匹配（=== 或 startsWith(path + '/')，避免 /about 命中 /aboutxxx）
    //   2) URL 有 pid 时只用 pid 精确匹配（最强信号，且排除共享路径的多命中）
    //   3) URL 无 pid 且多 item 共享同一 path 时，按 navList 顺序取第一个命中
    isNavActive(item, index) {
      const routePath = this.$route.path
      const routePid = this.$route.query.pid
      const myPath = this.getNavPath(item)
      if (!myPath) return false
      const pathMatch = routePath === myPath || routePath.startsWith(myPath + '/')
      if (!pathMatch) return false
      // 有 pid → pid 严格相等才算激活（防止公司简介/加入我们因共享 /about 同时高亮）
      if (routePid !== undefined && routePid !== null && String(routePid) !== '') {
        return String(routePid) === String(item.id)
      }
      // 没 pid → 在所有 path 命中的 item 里取 navList 第一个，避免共享路径的并列激活
      const firstIdx = this.navList.findIndex(n => {
        const p = this.getNavPath(n)
        return p && (routePath === p || routePath.startsWith(p + '/'))
      })
      return index === firstIdx
    },
    getAbout() {
      this.$api.home.getAbout({}).then(res => {
        if (!res || !res.data) return
        const config = res.data.config
        this.logo = this.getConfigValue(config, CONFIG_INDEX.LOGO)
        // 二维码组：后台 config 里 name=qrcodes 存 JSON 数组 [{name,img},...]；兼容旧单值 name=qrcode
        this.qrItems = this.parseQrCodes(config)
        // 首屏文案固定走前端语言包（与品牌稿一致），不受后台 Banner 配置干扰。
        // 若日后要后台可改，把下面三行改回 CONFIG_INDEX 读取即可。
        this.heroTitle = this.$t('m.heroTitleRow1')
        this.heroTitle2 = this.$t('m.heroTitleRow2')
        this.heroSubtitle = this.$t('m.heroFallbackSubtitle')
      }).catch(() => {})
    },
    /**
     * 导航名称处理：后台存的是英文名，中文站走映射表，英文站直接用原名
     */
    translateName(name) {
      // 整站英文暂下线：导航名称统一按中文映射
      return translateNavName(name, 'zh')
    },
    // 解析首页首屏二维码组：
    //   1) name=qrcodes 存 JSON 数组 [{name,img},...]
    //   2) 逗号分隔的图片路径串（FastAdmin 图片多选控件存法）：/uploads/a.png,/uploads/b.png
    //   3) 单图路径
    parseQrCodes(config) {
      const raw = getConfigByName(config, 'qrcodes') || getConfigByName(config, 'qrcode')
      if (!raw) return []
      const str = String(raw).trim()
      if (!str) return []
      // 1) JSON 数组 / 对象
      if (str.charAt(0) === '[' || str.charAt(0) === '{') {
        try {
          const arr = JSON.parse(str)
          const list = Array.isArray(arr) ? arr : [arr]
          const items = list
            .filter(item => item && (item.img || item.url_image))
            .map(item => ({
              img: item.img || item.url_image,
              name: item.name || item.title || ''
            }))
          if (items.length) return items
        } catch (e) { /* 落到逗号/单图分支 */ }
      }
      // 2) 逗号分隔多图：拆开逐个当二维码
      if (str.indexOf(',') > -1) {
        const parts = str.split(',').map(p => p.trim()).filter(Boolean)
        if (parts.length > 1) {
          return parts.map(img => ({ img, name: '' }))
        }
      }
      // 3) 单图
      return [{ img: str, name: '' }]
    },
    getnavList() {
      this.$api.home.getnavList({}).then(res => {
        if (!res || !res.data) return
        // 兼容两种返回结构：
        //  1) res.data.category 为分类数组（旧约定）
        //  2) res.data 本身是按 id 索引的分类对象/数组（线上实际返回）
        let category = res.data.category
        if (!Array.isArray(category)) {
          category = Array.isArray(res.data) ? res.data : Object.values(res.data)
        }
        if (!Array.isArray(category) || !category.length) return

        // 判定顶级：pid=0、自引用(pid 等于自身 id)、或 pid 指向不存在的分类，都视为顶级
        // （后台“加入我们”当前 pid=12 自引用，需按顶级处理，子分类才能正确挂载）
        const allIds = new Set(category.map(i => i.id))
        const isTop = item => item.pid === 0 || item.pid === item.id || !allIds.has(item.pid)

        // 如果后端已经按树形嵌好 child/children，直接复用；否则按 pid 平铺重建父子关系
        const titles = category.filter(isTop).map(item => {
          item.name = this.translateName(item.name)
          if (!item.child || !item.child.length) {
            item.child = Array.isArray(item.children) ? item.children : []
          }
          return item
        })
        const children = category.filter(item => !isTop(item))

        // 初始化顶级分类，建立 id 索引方便子级挂载
        const titleMap = {}
        titles.forEach(item => {
          titleMap[item.id] = item
        })

        // 挂载子级到对应父级；如果后端 pid 指向一个不存在的父级（数据异常/未保存成功），
        // 则把它提升为顶级显示，避免分类在导航里直接消失
        children.forEach(i => {
          i.name = this.translateName(i.name)
          const parent = titleMap[i.pid]
          if (parent) {
            parent.child.push(i)
          } else if (!titleMap[i.id]) {
            titles.push(i)
            titleMap[i.id] = i
          }
        })

        this.navList = titles
      }).catch(() => {})
    },
    // 在导航树（一级 + 二级）里按名称关键字找目标，菜单调整也不会跳错页
    findNavItem(keyword) {
      for (const top of this.navList) {
        if (top.name && top.name.indexOf(keyword) > -1) return top
        if (top.child && top.child.length) {
          const child = top.child.find(i => i.name && i.name.indexOf(keyword) > -1)
          if (child) return child
        }
      }
      return null
    },
    pushNav(item) {
      if (!item) return
      this.$router.push({
        path: this.getNavPath(item),
        query: { pname: item.name, pid: item.id }
      })
    },
    // 首屏按钮1：走进聚合贵 → 企业资质
    goQualification() {
      const target = this.findNavItem('资质') ||
        this.navList.find(i => i.type === 'imglist') ||
        null
      this.pushNav(target)
    },
    // 首屏按钮2：产品中心
    goProducts() {
      const target = this.findNavItem('产品') ||
        this.navList.find(i => i.type === 'table') ||
        null
      this.pushNav(target)
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  min-width: 1200px;
}

/* ========== 导航栏 ========== */
.nav-bar {
  background-color: var(--color-bg-white);
  box-shadow: var(--shadow-sm);
  position: relative;
  z-index: 100;
}

.nav-inner {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-box {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.logo-img {
  height: 50px;
  max-width: 280px;
  object-fit: contain;
}

.logo-text {
  font-size: 28px;
  font-weight: var(--font-weight-bold);
  color: var(--color-primary);
}

/* 导航菜单 */
.nav-menu {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  padding: 0 20px;
}

.nav-link {
  display: block;
  height: 80px;
  line-height: 80px;
  font-size: var(--font-size-base);
  color: var(--color-text-regular);
  text-decoration: none;
  transition: color var(--transition-fast);
  position: relative;
}

.nav-link:hover,
.nav-link.active {
  color: var(--color-primary);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: var(--color-primary);
  border-radius: 2px;
}

/* 含二级分类的栏目下拉箭头 */
.nav-caret {
  display: inline-block;
  margin-left: 6px;
  border: 4px solid transparent;
  border-top-color: currentColor;
  vertical-align: middle;
  transition: transform var(--transition-fast);
}

.nav-item.has-child:hover .nav-caret {
  transform: rotate(180deg);
}

/* 二级菜单 */
.sub-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 160px;
  background-color: var(--color-bg-white);
  box-shadow: var(--shadow-md);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  padding: 8px 0;
  margin: 0;
  list-style: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all var(--transition-normal);
  z-index: 200;
}

/* 透明桥接区：填补栏目与子菜单之间的间隙，避免鼠标移动时下拉收起 */
.sub-menu::before {
  content: '';
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  height: 12px;
}

.nav-item.has-child:hover .sub-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.sub-menu-item {
  padding: 0;
}

.sub-menu-link {
  display: block;
  padding: 12px 20px;
  font-size: var(--font-size-sm);
  color: var(--color-text-regular);
  text-decoration: none;
  transition: all var(--transition-fast);
}

.sub-menu-link:hover {
  background-color: var(--color-primary-bg);
  color: var(--color-primary);
  padding-left: 24px;
}

/* ========== 品牌首屏 ========== */
.brand-hero {
  position: relative;
  height: 480px;
  background-color: var(--color-bg-dark);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.hero-inner {
  position: relative;
  z-index: 1;
  color: var(--color-text-inverse);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  /* 容器加大到 1400px：覆盖 .container 的 1200px，给右侧二维码腾出右移空间（数值改这里可调） */
  width: 1500px;
  margin: 0 auto;
}

.hero-text {
  flex: 1;
  min-width: 0;
  /* 文字位置补偿：容器加宽 200px，但左侧 padding 100px 抵消，使文字左缘 = 原 1200 容器居中时的左缘 */
  padding-left: 100px;
}

/* ========== 首屏二维码区 ==========
   📌 位置调整指南（改数值 → 保存 → 热更新即时生效）：
   · 左右移动：改 .hero-qrcode 里的 margin-left / margin-right（auto=推到最右）
   · 上下移动：加 margin-top（正值往下 / 负值往上）
   · 两码间距：改 .hero-qrcode 的 gap
   · 码的大小：改 .hero-qrcode-box 的 width/height
*/
.hero-qrcode {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;     /* flex-start=顶部对齐 · center=垂直居中 · flex-end=贴底 */
  justify-content: center;     /* 多码水平排布：center · flex-start · space-between */
  gap: 30px;                   /* ← 两个码之间的左右间距：改大拉开/改小挤拢 */
  margin-left: 160px;          /* ← 二维码块右移 160px（容器已加大到 1400，这里才真正生效） */
}

/* 单码一列：一张图 + 一行说明文字，上下排列 */
.hero-qrcode-col {
  display: flex;
  flex-direction: column;
  align-items: center;         /* 图与下方文字水平居中 */
  gap: 14px;                   /* 图与下方文字的垂直间距 */
  text-align: center;
}

/* 白底卡片：改这里控制码的显示大小 */
.hero-qrcode-box {
  width: 200px;
  height: 200px;
  background-color: #FBF6EC;
  border-radius: var(--radius-md);
  padding: 12px;               /* 图距白边内边距（想图更满就改小，更空就改大） */
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);  /* 卡片阴影，不想要可删 */
}

.hero-qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: contain;         /* 图片等比缩放、不裁剪不变形 */
  display: block;
}

/* 二维码下方说明文字（来自后台 q.name，空名时模板不渲染该元素）
   限宽与白卡一致(200px)，超长自动折成第二行 */
.hero-qrcode-caption {
  margin: 0;
  font-size: var(--font-size-sm);
  letter-spacing: 4px;
  color: #E0D2B6;
  max-width: 190px;          /* ← 与 .hero-qrcode-box 同宽：文字超此宽度换第二行 */
  line-height: 1.6;          /* 换行后行距 */
  white-space: normal;       /* 允许折行 */
  word-break: break-all;     /* 超长串（如网址/英文）也能断行，不撑破 */
}

.hero-eyebrow {
  font-size: var(--font-size-lg);
  letter-spacing: 6px;
  color: #E0C9A2;
  margin-bottom: 20px;
}

.hero-title {
  font-size: 50px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-inverse);
  letter-spacing: 5px;
  line-height: 1.35;
  margin: 0 0 18px 0;
  font-family: 'Noto Serif SC', 'Songti SC', 'SimSun', Georgia, serif;
}

.hero-title-1 {
  display: block;
  color: var(--color-text-inverse);
}

.hero-title-2 {
  display: block;
  color: var(--color-primary);
  margin-top: 4px;
}

.hero-sub {
  font-size: var(--font-size-lg);
  color: #E0D2B6;
  letter-spacing: 2px;
  line-height: 1.8;
  margin: 0 0 38px 0;
  max-width: 620px;
}

.hero-acts {
  display: flex;
  align-items: center;
  gap: 18px;
}

.hero-btn {
  display: inline-block;
  cursor: pointer;
  font-size: 15px;
  letter-spacing: 2px;
  transition: all var(--transition-fast);
  border-radius: var(--radius-sm);
}

.hero-btn-main {
  background-color: var(--color-primary);
  color: var(--color-text-inverse);
  padding: 13px 38px;
}

.hero-btn-main:hover {
  background-color: var(--color-primary-dark);
  box-shadow: var(--shadow-primary);
}

.hero-btn-ghost {
  color: var(--color-text-inverse);
  border: 1px solid rgba(246, 239, 225, 0.65);
  padding: 12px 36px;
}

.hero-btn-ghost:hover {
  border-color: var(--color-primary);
  color: var(--color-primary-light);
  background-color: rgba(166, 83, 31, 0.16);
}

/* ========== 公告条 ========== */
.notice-bar {
  background-color: var(--color-bg-lighter);
  border-bottom: 1px solid var(--color-border-light);
}

.notice-inner {
  height: 50px;
  display: flex;
  align-items: center;
}

.notice-label {
  display: flex;
  align-items: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-primary);
  margin-right: 20px;
  flex-shrink: 0;
}

.notice-icon {
  width: 20px;
  height: 18px;
  margin-right: 8px;
}

.notice-content {
  flex: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.notice-text {
  font-size: var(--font-size-sm);
  color: var(--color-text-regular);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color var(--transition-fast);
}

.notice-content:hover .notice-text {
  color: var(--color-primary);
}

.notice-date {
  font-size: var(--font-size-xs);
  color: var(--color-text-placeholder);
  margin-left: 16px;
  flex-shrink: 0;
}

.notice-more {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 20px;
  transition: color var(--transition-fast);
}

.notice-more:hover {
  color: var(--color-primary);
}
</style>
